<template>
  <span v-show="isShowPage">
    <v-row>
      <v-col v-for="(item, idx) in cardItems" :key="idx" cols="12" md="4" lg="4">
        <v-card color="#716EC8" class="card-dashboard3" :loading="isFetching2">
          <template slot="progress">
            <v-progress-linear
              color="primary"
              height="2"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-text>
            <span class="card-dashboard-title3">
              {{ item.title }}
            </span><br />
            <span v-if="item.id === 'evCount'" class="card-dashboard-value3">
              {{ item.value }}
            </span>
            <span v-else class="card-dashboard-value3">
              {{ formatCurrency(item.value) }}
            </span>
            <!-- <span class="card-dashboard-unit3">{{ item.title }}</span> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <span class="page-sub-title">{{ table_title }}</span>
    <v-row align="center" justify="center">
      <v-col class="pt-0 pb-0" align-self="center">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          outlined
          solo
          hide-details
          v-model="search"
          class="search"
          placeholder="Search..."
          v-on:keyup.enter="getDataTable()"
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="pt-0 pb-0" align-self="center">
        <v-btn
          color="primary"
          class="white--text ma-5 float-right"
          @click="exportExcel()"
        >
          Export Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <Table :headers="headers" :loading="isFetching" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="5">
          <template slot="bodyNo" slot-scope="{ item }">
            <span v-if="item.bodyNo">{{ item.bodyNo }}</span>
            <span v-else>-</span>
          </template>
          <template slot="machineNo" slot-scope="{ item }">
            <span v-if="item.machineNo">{{ item.machineNo }}</span>
            <span v-else>-</span>
          </template>
          <template slot="kwh" slot-scope="{ item }">
            {{ formatCurrency(item.kwh) }}
          </template>
          <template slot="rp" slot-scope="{ item }">
            {{ formatCurrency(item.rp) }}
          </template>
        </Table>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import Table from '../../components/Table.vue'
import DashboardService from '@/services/DashboardService'

const dashboardService = DashboardService.build()
export default {
  name: 'DataKendaraan',
  components: {
    Table
  },
  data: () => ({
    cardItems: [
      {
        value: 0,
        id: 'evCount',
        title: 'Jumlah Kendaraan',
        order_number: 0
      },
      {
        value: 0,
        id: 'kwh',
        title: 'Akumulasi kWh',
        order_number: 1
      },
      {
        value: 0,
        id: 'rp',
        title: 'Total Rp',
        order_number: 2
      }
    ],
    headers: [
      { value: 'number', text: 'No.', sortable: false, align: 'center', width: '70px' },
      { value: 'countryName', text: 'Negara Delegasi', align: 'left', width: '150px' },
      { value: 'vehicleType', text: 'Tipe Kendaraan', align: 'center', width: '150px' },
      { value: 'nopol', text: 'No. Polisi', align: 'center', width: '150px' },
      { value: 'bodyNo', text: 'No. Rangka', align: 'center', width: '150px' },
      { value: 'machineNo', text: 'No. Mesin', align: 'center', width: '150px' },
      // { value: 'spkluName', text: 'Lokasi SPKLU', align: 'center', width: '150px' },
      // { value: 'charger', text: 'Charger', align: 'center', width: '180px' },
      // { value: 'lastChargingTime', text: 'Last Charging Time', align: 'left', width: '220px' },
      // { value: 'soc', text: 'SoC', align: 'center', width: '150px' },
      { value: 'kwh', text: 'kWh', align: 'right', width: '80px' },
      { value: 'rp', text: 'Total Rp', align: 'right', width: '130px' }
    ],
    items: {},
    search: '',
    sortSettings: '',
    isFetching: false, // for datatable
    isFetching2: false, // for cards
    input: {
      filter_by: ''
    },
    isShowPage: false,
    table_title: ''
  }),
  async created () {
    // delete localStorage
    localStorage.removeItem('tableQuery')
    this.table_title = 'Data Kendaraan'
    await this.getCardData()
    this.isShowPage = true
  },
  computed: {},
  mounted: function () {
    // this.$nextTick(() => {
    //   if (this.$route.path === '/monitoring/data-kendaraan') {
    //     // re-get data every 1 minute
    //     window.setInterval(() => {
    //       this.resetData()
    //       this.getCardData()
    //       const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
    //       if (tableQuery) {
    //         this.getDataTable(tableQuery.page, tableQuery.size)
    //       } else {
    //         this.getDataTable()
    //       }
    //     }, 60000)
    //   }
    // })
  },
  watch: {
    search: function (val) {
      if (val === '') {
        this.getDataTable()
      }
    }
  },
  methods: {
    async resetData () {
      this.cardItems = [
        {
          value: 0,
          id: 'evCount',
          title: 'Jumlah Kendaraan',
          order_number: 0
        },
        {
          value: 0,
          id: 'kwh',
          title: 'Akumulasi kWh',
          order_number: 1
        },
        {
          value: 0,
          id: 'rp',
          title: 'Total Rp',
          order_number: 2
        }
      ]
      this.items = {}
      // this.search = ''
      this.sortSettings = ''
    },
    async getCardData () {
      const response = await dashboardService.getDataKendaraanCard()

      if (response.data.status === 200) {
        this.isFetching3 = true
        const dataCard = response.data.data
        this.cardItems[0].value = dataCard.evCount
        this.cardItems[1].value = dataCard.kwh
        this.cardItems[2].value = dataCard.rp
        this.isFetching3 = false
      }
    },
    async getDataTable (page, size) {
      // this.isFetching = true
      this.paging.page = page
      this.paging.size = size

      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      localStorage.setItem('tableQuery', JSON.stringify({
        page: page,
        size: size,
        sort_by: tableQuery ? tableQuery.sort_by : ''
      }))

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const param = Object.assign({
        q: this.search,
        sort: tableQuery ? tableQuery.sort_by : ''
      }, this.paging)

      const response = await dashboardService.getDataKendaraanPgb(param)
      if (response.data.status === 401) {
        alert.breaksession()
      }
      if (response.data.status === 200) {
        const { data: { data: { content, totalPages, number, size, totalElements } } } = response
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size,
          page: number + 1,
          totalElements
        })
      } else {
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      // this.isFetching = false
    },
    async updateSortDatatable (options) {
      if (options.sortBy) {
        this.sortSettings = ''
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
          let column = ''

          if (options.sortBy[i] === 'countryName') {
            column = 'countryName'
          } else if (options.sortBy[i] === 'vehicleType') {
            column = 'vehicleType'
          } else if (options.sortBy[i] === 'nopol') {
            column = 'nopol'
          } else if (options.sortBy[i] === 'bodyNo') {
            column = 'bodyNo'
          } else if (options.sortBy[i] === 'machineNo') {
            column = 'machineNo'
          } else if (options.sortBy[i] === 'kwh') {
            column = 'kwh'
          } else if (options.sortBy[i] === 'rp') {
            column = 'rp'
          }

          if (i === 0) {
            this.sortSettings += column + ',' + sort
          } else {
            this.sortSettings += '&sort=' + column + ',' + sort
          }
        }

        let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        localStorage.setItem('tableQuery', JSON.stringify({
          page: tableQuery ? tableQuery.page : 0,
          size: tableQuery ? tableQuery.size : 20,
          sort_by: this.sortSettings
        }))
        tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        this.getDataTable(tableQuery.page, tableQuery.size)
      }
    },
    async exportExcel () {
      const param = {
        name: 'Data Kendaraan ' + new Date() + '.xlsx'
      }
      await dashboardService.getDataExcel(param)
    }
  }
}
</script>
<style scoped>
</style>
